<template>
  <div class="multimedia">
    <AppleTvVideo :video-name="require('@/assets/videos/multimedia.mp4')"></AppleTvVideo>
    <div class="texts">
      <h3>{{ $t("pages.multimedia.subtitle1") }}</h3>
      <p>{{ $t("pages.multimedia.text1") }}</p>
    </div>
  </div>
</template>

<script>
import AppleTvVideo from "../components/AppleTvVideo";
export default {
  name: "Multimedia",
  components: {AppleTvVideo}
};
</script>

<style lang="scss">
@import "../common/_variables.scss";
.multimedia {
  display: flex;
  align-items: center;
}
.texts {
  margin-left: 40px;
}
@media only screen and (max-width: $screen-lg) {
  .multimedia {
    display: block;
  }
  .texts {
    margin-left: 0;
  }
}
@media only screen and (max-width: $screen-xs) {
  .multimedia {
    margin-top: 40px;
  }
}
</style>
